export default function QuienesSomos() {
  return (
    <section id="nosotros" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Encabezado */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-600 text-xs font-semibold tracking-widest uppercase rounded-full mb-4">
            Quiénes Somos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
            Infraestructuras <span className="text-teal-500">HO LAASKS</span>
          </h2>
          <div className="w-16 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        {/* Contenido principal: imagen + texto */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">

          {/* Imagen */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/207177310b9abd83a3c3d5d478fef01c/f07f2c0e7de0e7c371330e62ada21151.png"
                alt="Equipo Infraestructuras HO LAASKS"
                className="w-full h-[420px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
            {/* Badge flotante */}
            <div className="absolute -bottom-6 -right-6 bg-teal-500 text-white rounded-2xl px-6 py-4 shadow-xl">
              <p className="text-3xl font-bold">+20</p>
              <p className="text-sm font-medium text-teal-100">Años de experiencia</p>
            </div>
            {/* Decoración */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-teal-50 rounded-2xl -z-10"></div>
          </div>

          {/* Texto */}
          <div className="space-y-5">
            <p className="text-gray-600 leading-relaxed text-base">
              Infraestructuras HO LAASKS es una empresa mexicana comprometida con el desarrollo del país, la responsabilidad social y la protección del medio ambiente. Desde nuestros inicios en el año 2005, hemos trabajado con dedicación en el sector de la construcción e infraestructura, brindando soluciones eficientes, innovadoras y de alta calidad para nuestros clientes.
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              Derivado del crecimiento constante de nuestras operaciones y de la confianza depositada por nuestros clientes a nivel nacional, en el año 2025 fortalecemos nuestra estructura como empresa, con eficiencia, capacidad técnica y compromiso con proyectos de mayor alcance.
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              En Infraestructuras HO LAASKS promovemos el desarrollo sustentable como un principio fundamental en cada uno de nuestros proyectos, procurando el uso responsable de los recursos, la implementación de prácticas constructivas eficientes y la generación de un impacto positivo en el entorno social y ambiental.
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              Asimismo, desarrollamos cada una de nuestras actividades ajustando nuestros procesos y trabajos a la normatividad vigente, cumpliendo con los estándares técnicos, de seguridad y calidad establecidos, con el objetivo de garantizar resultados confiables y responsables.
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              Nuestro objetivo es contribuir al desarrollo de la infraestructura que impulsa el progreso de México, siempre bajo principios de calidad, responsabilidad y respeto por el medio ambiente.
            </p>

            <div className="flex flex-wrap gap-4 pt-2">
              <a
                href="#servicios"
                className="px-6 py-3 bg-teal-500 text-white rounded-full text-sm font-semibold hover:bg-teal-600 transition-all shadow-md whitespace-nowrap cursor-pointer"
              >
                Ver Servicios
              </a>
              <a
                href="#contacto"
                className="px-6 py-3 border-2 border-teal-500 text-teal-600 rounded-full text-sm font-semibold hover:bg-teal-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Contáctanos
              </a>
            </div>
          </div>
        </div>

        {/* Separador con acento */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-gray-200"></div>
          <div className="flex items-center gap-2 px-4">
            <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
            <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">Nuestros Pilares</span>
            <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
          </div>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        {/* Valores / Pilares */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Misión */}
          <div className="group relative bg-gray-50 hover:bg-teal-500 rounded-2xl p-8 transition-all duration-300 cursor-default overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 bg-teal-100/40 group-hover:bg-white/10 rounded-bl-full transition-all duration-300"></div>
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 group-hover:bg-white/20 rounded-xl mb-6 transition-all">
              <i className="ri-focus-3-line text-2xl text-teal-600 group-hover:text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 group-hover:text-white mb-3 transition-colors">Nuestra Misión</h3>
            <p className="text-gray-500 group-hover:text-teal-50 text-sm leading-relaxed transition-colors">
              Contribuir al desarrollo de la infraestructura que impulsa el progreso de México, siempre bajo principios de calidad, responsabilidad y respeto por el medio ambiente.
            </p>
          </div>

          {/* Visión */}
          <div className="group relative bg-gray-50 hover:bg-teal-500 rounded-2xl p-8 transition-all duration-300 cursor-default overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 bg-teal-100/40 group-hover:bg-white/10 rounded-bl-full transition-all duration-300"></div>
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 group-hover:bg-white/20 rounded-xl mb-6 transition-all">
              <i className="ri-eye-line text-2xl text-teal-600 group-hover:text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 group-hover:text-white mb-3 transition-colors">Nuestra Visión</h3>
            <p className="text-gray-500 group-hover:text-teal-50 text-sm leading-relaxed transition-colors">
              Ser una empresa líder en el sector de la construcción e infraestructura a nivel nacional, reconocida por su innovación, transparencia y capacidad técnica en proyectos de alto impacto.
            </p>
          </div>

          {/* Valores */}
          <div className="group relative bg-gray-50 hover:bg-teal-500 rounded-2xl p-8 transition-all duration-300 cursor-default overflow-hidden">
            <div className="absolute top-0 right-0 w-24 h-24 bg-teal-100/40 group-hover:bg-white/10 rounded-bl-full transition-all duration-300"></div>
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 group-hover:bg-white/20 rounded-xl mb-6 transition-all">
              <i className="ri-shield-star-line text-2xl text-teal-600 group-hover:text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 group-hover:text-white mb-3 transition-colors">Nuestros Valores</h3>
            <p className="text-gray-500 group-hover:text-teal-50 text-sm leading-relaxed transition-colors">
              Desarrollamos cada actividad ajustando nuestros procesos a la normatividad vigente, cumpliendo con los estándares técnicos, de seguridad y calidad establecidos, garantizando resultados confiables y responsables.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
